// Утилиты проверки прав с поддержкой wildcard

export type PermissionCode = string; // формат: domain[:resource[:...]]:action, допускаются * и xxx:*

// Нормализация: убираем лишние пробелы
const norm = (s: string) => s.trim();

// Проверка соответствия одного паттерна пользователю.
// Пример: hasPattern('users:*', 'users:update') => true
//         hasPattern('*', 'anything:any') => true
//         hasPattern('tickets:attachments:*', 'tickets:attachments:upload') => true
export function patternMatches(pattern: PermissionCode, requested: PermissionCode): boolean {
  const p = norm(pattern);
  const r = norm(requested);
  if (!p || !r) return false;
  if (p === '*' || r === '*') return p === '*';

  const pParts = p.split(':');
  const rParts = r.split(':');

  // Посегментное сравнение: * в любом сегменте совпадает с чем угодно в этом сегменте
  const len = Math.max(pParts.length, rParts.length);
  for (let i = 0; i < len; i++) {
    const pp = pParts[i];
    const rp = rParts[i];
    // Если паттерн закончился раньше, то несовпадение (кроме случая когда последний сегмент был '*')
    if (pp === undefined) return false;
    if (pp === '*') return true; // глобальный wildcard в этом или последующем сегменте покрывает остаток
    if (rp === undefined) {
      // requested короче; если в паттерне не '*', значит нет точного совпадения
      return false;
    }
    if (pp !== rp) {
      // допускаем окончание паттерна на :* (доменно-ресурсный wildcard)
      if (pp.endsWith('*')) {
        // например 'actions:*' → любой actions:...
        const base = pp.slice(0, -1);
        return rp.startsWith(base);
      }
      return false;
    }
  }
  return true;
}

// Проверка: есть ли у пользователя право requested с учётом выданных ему userPerms (могут содержать wildcard)
export function hasPermission(userPerms: PermissionCode[] | readonly PermissionCode[] | undefined | null, requested: PermissionCode): boolean {
  if (!userPerms || userPerms.length === 0) return false;
  for (const up of userPerms) {
    if (patternMatches(up, requested)) return true;
  }
  return false;
}

// Проверка массива прав: достаточно одного совпадения (логика any)
export function hasAnyPermission(userPerms: PermissionCode[] | readonly PermissionCode[] | undefined | null, required: PermissionCode[]): boolean {
  return required.some((r) => hasPermission(userPerms, r));
}

// Проверка массива прав: нужны все (логика all)
export function hasAllPermissions(userPerms: PermissionCode[] | readonly PermissionCode[] | undefined | null, required: PermissionCode[]): boolean {
  return required.every((r) => hasPermission(userPerms, r));
}

